import {Order} from "./components/Order";
import {DiscountTimer} from "./components/DiscountTimer";
import {PromocodeTimer} from "./components/PromocodeTimer";
import {OrderVote} from "./components/Order/Vote";
import BasketChanges from "./components/Order/BasketChanges";
import { FittingRequestPopup } from "./components/FittingRequest";

$(document).ready(function () {

    window.init_affix();

    $('.js-order').bindToEntity(Order);

    // Костыль для закрытия окна с размерами для мобилки
    $(document).on('click', function (event) {
        let element = $(event.target),
            sizesBlock = '.js-basket_item-sizes.active',
            colorsBlock = '.js-basket_item-colors.active';

        if (element.closest(sizesBlock).length <= 0 && element.closest('.js-toggle').length <= 0) {
            $(sizesBlock).find('.js-toggle').click();
        }

        if (element.closest(colorsBlock).length <= 0 && element.closest('.js-toggle').length <= 0) {
            $(colorsBlock).find('.js-toggle').click();
        }
    });

    let reserve_counter = $('.reserve_counter'), maxTimer = 600;

    if (reserve_counter.data('value') > 0) {
        reserve_function();

        reserve_counter.find('a').click(function() {
            event.preventDefault();
            $.post('/ajax/order/reserve_counter_reset/', {}, function() {
                reserve_counter.data('value', 0);
                reserve_function();
            });
        });
    }

    function reserve_function() {
        let timer = reserve_counter.data('value');

        if (timer >= maxTimer) {
            reserve_counter.find('p').show();
            reserve_counter.find('div:visible').hide();
        } else {
            reserve_counter.find('p:visible').hide();
            reserve_counter.find('div').show();
            reserve_counter.find('span').text(pad0(Math.floor((maxTimer - timer) / 60), 1) + ':' + pad0(Math.floor((maxTimer - timer) % 60)));
            reserve_counter.data('value', timer + 1);
            setTimeout(reserve_function, 1e3);
        }
    }

    let idle_discount = $('.idle_discount');

    if (idle_discount.data('value') > 0) {
        idle_discount_function();
    }

    function idle_discount_function() {
        let timer = idle_discount.data('value');

        if (timer >= maxTimer) {
            idle_discount.find('div:visible').hide();
        } else {
            idle_discount.find('div').show();
            idle_discount.find('span').text(pad0(Math.floor((maxTimer - timer) / 60), 1) + ':' + pad0(Math.floor((maxTimer - timer) % 60)));
            idle_discount.data('value', timer + 1);
            setTimeout(idle_discount_function, 1e3);
        }
    }

    function pad0(i,o) {return i<10?(o&&!i?'':'0')+i:i}

    new DiscountTimer();

    $('.js-model-predict__close').on('click', function(event){
        event.preventDefault();
        $(this).parent().hide();
    });

    $('.js-model-predict__form').on('submit', function(event){
        event.preventDefault();
        $.post('/ajax/order/model_predict/submit/');
        $('body').preloader('show');
        $(this).parent().parent().hide();
        window.location = window.location;
    });

    new PromocodeTimer();

    $('.viewed-slider').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: window.TABLET_BREAKPOINT,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    arrows: false,
                    autoplay: true,
                    autoplaySpeed: 5000
                },
            },
            {
                breakpoint: window.MOBILE_BREAKPOINT,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                    autoplay: true,
                    autoplaySpeed: 5000
                },
            },
        ],
    });

    // Для рефералов подгружаем попап динамически
    $(document).on('click', '[data-entity="referal-apply-link"]', e => {
        e.preventDefault();

        BX.ajax.runComponentAction('mario:referral.apply', 'modal')
            .then(({ data }) => {
                const modal = BX.Tag.render`${data}`;
                const $modal = $(modal);

                BX.Dom.append(
                    modal,
                    document.body
                );

                $modal.modal('show');
                $modal.on('hidden.bs.modal', () => {
                    BX.Dom.remove(modal);
                });

                if ('__initApplyReferral' in window) {
                    window.__initApplyReferral(modal);
                } else {
                    BX.loadScript('/assets/scripts/referral.js', () => {
                        window.__initApplyReferral(modal);
                    });
                }
            });
    });

    // Голосование
    [...document.querySelectorAll('[data-entity="order-vote"]')]
        .forEach(rootNode => new OrderVote({ rootNode }));

    // Изменения в корзине
    [...document.querySelectorAll('#basket_changes')]
        .forEach(rootNode => {
            new BasketChanges({ rootNode });
            window.refreshHeaderBasket();
        });
    
    // Примерка в 1 клик
    document.querySelectorAll('[data-entity="fitting-request"]')
        .forEach(rootNode => new FittingRequestPopup(rootNode, { showAfter: 10000, ymPrefix: 'order_' }));
});

window.init_affix = () => {
    if ($(window).width() > TABLET_BREAKPOINT) {
        createAffix(
            $('.order-about-parent'),
            getOuterHeight($('.breadcrumbs-sec')) + getOuterHeight($('.block-table')) + getOuterHeight($('.step1')),
            instagramOffsetBottom
        );
    }
};
